import { render, staticRenderFns } from "./yatongdian.vue?vue&type=template&id=33735cfc&scoped=true"
import script from "./yatongdian.vue?vue&type=script&lang=ts"
export * from "./yatongdian.vue?vue&type=script&lang=ts"
import style0 from "./yatongdian.vue?vue&type=style&index=0&id=33735cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33735cfc",
  null
  
)

export default component.exports